import React, { useState } from 'react';

import { useIntl } from 'react-intl';
import { Col } from 'react-bootstrap';
import { decode } from 'html-entities';

import { useAppSelector } from 'hooks';
import { CalendarIcon } from 'assets/icons';
import { formatRecurrence } from 'utils/Time';
import { DropdownGroup } from 'components/Forms';

import DeleteMessageModal from './DeleteMessageModal';
import AddEditMessageModal from './AddEditMessageModal';

export const MessageContent = ({ message }: { message: ICarePlanMessage }) => {
  const intl = useIntl();
  const locale = useAppSelector((state) => state.intl.locale);
  return (
    <div className="p-3 bg-light font-weight-bolder">
      <div className="text-sm font-weight-bolder white-space-break-spaces">
        « {decode(message.message)} »
      </div>
      {message.recurrence_hr && (
        <div className="text-sm font-weight-bolder mt-2">
          <CalendarIcon className="icon me-2" style={{ fontSize: '14px' }} />
          {formatRecurrence(message.recurrence_hr, locale, intl.formatMessage({ id: 'atKey' }))}
        </div>
      )}
    </div>
  );
};

interface IMessageContainerProps {
  message: ICarePlanMessage;
  onDelete: (id: string) => any;
  handleEdit: any;
  carePlanTemplate?: ICarePlanTemplate;
  dataTestId: string;
  disabled?: boolean;
}

const Message = ({
  message,
  onDelete,
  handleEdit,
  carePlanTemplate,
  dataTestId,
  disabled
}: IMessageContainerProps) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const isTemplateGlobal = carePlanTemplate?.template_type === 'GLOBAL';

  const handleEditMessage = () => {
    setShowEditModal(false);
    handleEdit();
  };
  const handleDeleteMessage = () => {
    onDelete(message.id);
  };

  return (
    <Col lg={6} xl={4} className="p-3" data-test={dataTestId}>
      <div className="bg-light">
        {!isTemplateGlobal && (
          <DropdownGroup
            dataTestId={dataTestId}
            onShowEditModal={() => setShowEditModal(true)}
            onShowDeleteModal={() => setShowDeleteModal(true)}
            disabled={disabled}
          />
        )}
        <MessageContent message={message} />
      </div>

      {showEditModal && (
        <AddEditMessageModal
          show={showEditModal}
          handleClose={() => setShowEditModal(false)}
          handleEdit={handleEditMessage}
          message={message}
          carePlanTemplate={carePlanTemplate}
        />
      )}
      <DeleteMessageModal
        show={showDeleteModal}
        setShow={setShowDeleteModal}
        message={message}
        onDelete={handleDeleteMessage}
        carePlanTemplate={carePlanTemplate}
      />
    </Col>
  );
};

export default Message;
